import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=0711db0c&scoped=true"
import script from "./InvitationForm.vue?vue&type=script&lang=js"
export * from "./InvitationForm.vue?vue&type=script&lang=js"
import style0 from "./InvitationForm.vue?vue&type=style&index=0&id=0711db0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711db0c",
  null
  
)

export default component.exports